import { COMPACTAR_VARIANT } from "../../hooks/useCompactarStatus";
import { InfoIcon, ArrowOnRectangle } from '../../components/icons/SvgIcons';
import Button from "../../components/button";

// ---------------------------------------------------------------------------
// Subcomponentes internos
// ---------------------------------------------------------------------------

function InfoIconButton({ onClick }) {
  return (
    <button onClick={onClick} aria-label="Información sobre compactación">
      <InfoIcon className="size-6" />
    </button>
  );
}

// ---------------------------------------------------------------------------
// Contenedor base
// ---------------------------------------------------------------------------

function SectionCard({ children }) {
  return (
    <div className="sm:gap-4 bg-white rounded-[8px] border border-[#61ABCF] divide-y divide-[#61ABCF]">
      {children}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Variantes
// ---------------------------------------------------------------------------

function CompactadoBadge({ onInfo }) {
  return (
    <SectionCard>
      <div className="py-2 grid grid-cols-2 px-4 items-center">
        <dt className="items-center flex gap-1 text-sm/6 font-bold text-[#036395] font-inter">
          COMPACTADO
          <InfoIconButton onClick={onInfo} />
        </dt>
        <dd className="mt-1 text-sm/6 text-gray-700 sm:mt-0">
          <div className="flex gap-[4px] px-3 py-2 text-xs ml-3 text-center text-white bg-[#0477AD] rounded-lg">
            Vehículo compactado
          </div>
        </dd>
      </div>
    </SectionCard>
  );
}

function CompactarBloqueadoJuzgado({ onInfo }) {
  return (
    <SectionCard>
      <div className="py-2 grid grid-cols-2 px-4">
        <dt className="items-center flex gap-1 text-sm/6 font-bold text-[#036395] font-inter">
          COMPACTACION
          <InfoIconButton onClick={onInfo} />
        </dt>
        <dd className="mt-1 text-sm/6 text-gray-700 sm:mt-0">
          <Button size="sm" disabled>
            Compactar
          </Button>
        </dd>
      </div>
      <div className="py-2 grid px-4">
        <dt className="text-sm/6 font-medium text-gray-900">
          Compactación bloqueada desde juzgado
        </dt>
      </div>
    </SectionCard>
  );
}

function CompactarPuede({ onInfo, onCompactar }) {
  return (
    <SectionCard>
      <div className="py-2 grid grid-cols-2 px-4">
        <dt className="items-center flex gap-1 text-sm/6 font-bold text-[#036395] font-inter">
          COMPACTACION
          <InfoIconButton onClick={onInfo} />
        </dt>
        <dd className="mt-1 text-sm/6 text-gray-700 sm:mt-0">
          <Button size="sm" onClick={onCompactar} icon={<ArrowOnRectangle className="size-4" />}>
            Compactar
          </Button>
        </dd>
      </div>
    </SectionCard>
  );
}

function CompactarSinInfo({ onInfo, onCompactar }) {
  return (
    <SectionCard>
      <div className="py-2 grid grid-cols-2 px-4">
        <dt className="items-center flex gap-1 text-sm/6 font-bold text-[#036395] font-inter">
          COMPACTACION
          <InfoIconButton onClick={onInfo} />
        </dt>
        <dd className="mt-1 text-sm/6 text-gray-700 sm:mt-0">
          <Button size="sm" onClick={onCompactar} icon={<ArrowOnRectangle className="size-4" />}>
            Compactar
          </Button>
        </dd>
      </div>
      <div className="py-2 grid px-4">
        <dt className="text-sm/6 font-medium text-gray-900">
          No hay información de juzgado sobre este vehículo, la compactación
          queda a criterio de corralón
        </dt>
      </div>
    </SectionCard>
  );
}

function CompactarBloqueadoCorralon({ onInfo }) {
  return (
    <SectionCard>
      <div className="py-2 grid grid-cols-2 px-4">
        <dt className="items-center flex gap-1 text-sm/6 font-bold text-[#036395] font-inter">
          COMPACTACION
          <InfoIconButton onClick={onInfo} />
        </dt>
        <dd className="mt-1 text-sm/6 text-gray-700 sm:mt-0">
          <Button size="sm" disabled>
            Compactar
          </Button>
        </dd>
      </div>
      <div className="py-2 grid px-4">
        <dt className="text-sm/6 font-medium text-gray-900">
          Compactación bloqueada desde corralón
        </dt>
      </div>
    </SectionCard>
  );
}

// ---------------------------------------------------------------------------
// Componente principal exportado
// ---------------------------------------------------------------------------

/**
 * Renderiza la sección de compactación en DetailComponent.
 * La variante a mostrar se determina externamente con useCompactarStatus.
 *
 * @param {object}   props
 * @param {string}   props.variant     - Una de las constantes COMPACTAR_VARIANT
 * @param {function} props.onInfo      - Abre el modal informativo de compactación
 * @param {function} props.onCompactar - Abre el modal de compactación
 */
function CompactarSection({ variant, onInfo, onCompactar }) {
  switch (variant) {
    case COMPACTAR_VARIANT.OCULTO:
      return null;

    case COMPACTAR_VARIANT.YA_COMPACTADO:
      return <CompactadoBadge onInfo={onInfo} />;

    case COMPACTAR_VARIANT.BLOQUEADO_JUZGADO:
      return <CompactarBloqueadoJuzgado onInfo={onInfo} />;

    case COMPACTAR_VARIANT.PUEDE_COMPACTAR:
      return <CompactarPuede onInfo={onInfo} onCompactar={onCompactar} />;

    case COMPACTAR_VARIANT.SIN_INFO:
      return <CompactarSinInfo onInfo={onInfo} onCompactar={onCompactar} />;

    case COMPACTAR_VARIANT.BLOQUEADO_CORRALON:
      return <CompactarBloqueadoCorralon onInfo={onInfo} />;

    default:
      return null;
  }
}

export default CompactarSection;